import { useEffect } from 'react';
import styled from 'styled-components';
import { useTranslation } from '@yoweb/next-i18next';
import { Text, Title } from '@yoweb/ui/components/typography';
import { captureException } from '@yoweb/utils/sentry';
import { useExternalConfig } from '@poplar/contexts/ExternalConfig';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function ErrorSubstate(_ref) {
  var error = _ref.error;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useExternalConfig = useExternalConfig(),
      env = _useExternalConfig.env;

  var showErrorMessage = error && (env === 'local' || env === 'test');
  useEffect(function () {
    if (error) {
      captureException(error);
    }
  }, [error]);
  return /*#__PURE__*/_jsxs(ErrorSubstateContainer, {
    children: [/*#__PURE__*/_jsx(Title, {
      children: t('error.title')
    }), /*#__PURE__*/_jsx(Text, {
      children: t('error.description')
    }), showErrorMessage && /*#__PURE__*/_jsx(ErrorMessage, {
      children: JSON.stringify(error, undefined, 2)
    })]
  });
}
var ErrorSubstateContainer = styled.div.withConfig({
  componentId: "sc-14fr9t5-0"
})(["display:flex;align-items:center;justify-content:center;flex-direction:column;gap:1.5rem;"]);
var ErrorMessage = styled.code.withConfig({
  componentId: "sc-14fr9t5-1"
})(["font-family:Courier,monospace;border:1px solid #eee;padding:1rem;background:white;width:100%;border-radius:6px;"]);